import axios from 'axios';
import Toast from '../components/Common/Tostify/Toastify';
import { getCookie } from '../utility/helper';
import {
  SESSION_EXPIRED_MESSAGE,
  shouldLogoutForAuthError,
} from '../utility/errorMessages';

const baseURL = process.env.REACT_APP_BASE_URL;
const notificationsURL = process.env.REACT_APP_NOTIFICATIONS_URL;

export const baseURL2 = notificationsURL;

export const learnerId = getCookie('userid');

const http = axios.create({ baseURL: baseURL });
let isAuthToastShown = false;

const clearAllCookies = () => {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const cookieName = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
};

const logoutForExpiredSession = () => {
  if (isAuthToastShown) {
    return;
  }

  isAuthToastShown = true;
  Toast.error(SESSION_EXPIRED_MESSAGE);
  setTimeout(() => {
    localStorage.clear();
    clearAllCookies();
    window.location.href = '/login';
  }, 2000);
};

http.interceptors.request.use(
  (request) => {
    const applicationId = getCookie('applicationId');
    const token = getCookie('TOKEN_NAME');
    const config = getCookie('config');
    const userLanguage = localStorage.getItem('i18nextLng') || 'en-US';
    request.headers['x-tenant-id'] = applicationId;
    request.headers['x-access-token'] = token;
    request.headers['x-config'] = config;
    request.headers['Accept-Language'] = userLanguage;
    return request;
  },
  (err) => Promise.reject(err)
);

http.interceptors.response.use(
  (response) => {
    if (
      shouldLogoutForAuthError(
        response?.data?.statusCode,
        response?.data?.message
      )
    ) {
      logoutForExpiredSession();
    }

    return response;
  },
  (error) => {
    if (
      shouldLogoutForAuthError(
        error?.response?.data?.statusCode ?? error?.response?.status,
        error?.response?.data?.message
      )
    ) {
      logoutForExpiredSession();
    }

    return Promise.reject(error);
  }
);

export default http;

export const httpNotification = axios.create({ baseURL: baseURL2 });

httpNotification.interceptors.request.use(
  (request) => {
    const applicationId = getCookie('applicationId');
    const token = getCookie('TOKEN_NAME');
    const userLanguage = localStorage.getItem('i18nextLng') || 'en-US';
    request.headers['x-tenant-id'] = applicationId;
    request.headers['x-access-token'] = token;
    request.headers['Accept-Language'] = userLanguage;
    return request;
  },
  (err) => Promise.reject(err)
);

export const https = axios.create({ baseURL: baseURL });

https.interceptors.request.use(
  (request) => {
    const applicationId = getCookie('applicationId');
    const token = getCookie('TOKEN_NAME');
    const userLanguage = localStorage.getItem('i18nextLng') || 'en-US';
    request.headers['x-tenant-id'] = applicationId;
    request.headers['x-access-token'] = token;
    request.headers['Accept-Language'] = userLanguage;
    return request;
  },
  (err) => Promise.reject(err)
);
